import * as React from "react";

import PermMediaOutlinedIcon from "@material-ui/icons/PhotoSizeSelectActual";
import PeopleIcon from "@material-ui/icons/People";
import DnsRoundedIcon from "@material-ui/icons/DnsRounded";
import TimerIcon from "@material-ui/icons/Timer";
import SettingsIcon from "@material-ui/icons/Settings";
import PhonelinkSetupIcon from "@material-ui/icons/PhonelinkSetup";

export const categories = [
  {
    id: "ショー管理メニュー",
    children: [
      // {
      //   id: "参加ユーザ",
      //   icon: <PeopleIcon />,
      //   active: true,
      //   to: "/audiences",
      // },
      // {
      //   id: "チケット",
      //   icon: <DnsRoundedIcon />,
      //   to: "/tickets",
      //   active: false,
      // },
      {
        id: "ティザー",
        icon: <PermMediaOutlinedIcon />,
        to: "/teasers",
        active: false,
      },
      {
        id: "メイン",
        icon: <PermMediaOutlinedIcon />,
        to: "/mains",
        active: false,
      },
      {
        id: "セッティング",
        icon: <SettingsIcon />,
        to: "/settings",
        active: false,
      },
      {
        id: "ブース",
        icon: <PermMediaOutlinedIcon />,
        to: "/booths",
        active: false,
      },
      // {
      //   id: "フォトアルバム(仮)",
      //   icon: <PermMediaOutlinedIcon />,
      //   to: "/albums",
      //   active: false,
      // },
      {
        id: "イメージ素材",
        icon: <PermMediaOutlinedIcon />,
        to: "/images",
        active: false,
      },
    ],
  },
  // {
  //   id: "Quality",
  //   children: [
  //     { id: "Analytics", icon: <SettingsIcon />, to: "/users", active: false },
  //     { id: "Performance", icon: <TimerIcon />, to: "/users", active: false },
  //     {
  //       id: "Test Lab",
  //       icon: <PhonelinkSetupIcon />,
  //       to: "/users",
  //       active: false,
  //     },
  //   ],
  // },
];
